import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _UPDATE_TILE_STRATEGI;

import { UpdateTileStrategy } from "./types";
import { updateTileStateOverlap, updateTileStateRealtime, updateTileStateReplace } from "./utils/strategies";
export var TILE_SIZE = 256;
export var DEFAULT_EXTENT = [-Infinity, -Infinity, Infinity, Infinity];
export var BOUNDS_BUFFER_SCALE = 0.2;
export var DEFAULT_CACHE_SCALE = 5; // 瓦片更新显示策略

export var UPDATE_TILE_STRATEGIES = (_UPDATE_TILE_STRATEGI = {}, _defineProperty(_UPDATE_TILE_STRATEGI, UpdateTileStrategy.Realtime, updateTileStateRealtime), _defineProperty(_UPDATE_TILE_STRATEGI, UpdateTileStrategy.Overlap, updateTileStateOverlap), _defineProperty(_UPDATE_TILE_STRATEGI, UpdateTileStrategy.Replace, updateTileStateReplace), _UPDATE_TILE_STRATEGI);
export var NOOP = function NOOP() {//
};